(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["first-box-chooser"]) return;
  try {
    
(() => {
  'use strict';
  let controller;
  function initializeFirstBox() {
    const root = document.querySelector('[data-first-box-root]');
    const languageNode = root?.querySelector('#first-box-language');
    const productNode = root?.querySelector('#first-box-product-data');
    if (!root || !languageNode || !productNode) return;
    controller?.abort();
    controller = new AbortController();
    const { signal } = controller;
    const language = JSON.parse(languageNode.textContent);
    const data = JSON.parse(productNode.textContent);
    const variants = new Map((data.variants || []).map(v => [String(v.id), v]));
    const dimensions = {
      '53383155286289': { size: 16, jars: 6 },
      '53383155319057': { size: 16, jars: 12 },
      '53383155384593': { size: 32, jars: 6 },
      '53383155417361': { size: 32, jars: 12 }
    };
    const get = id => root.querySelector('#' + id);
    const copy = (key, values = {}) => language[key].replace(/__(\w+)__/g, (_, name) => values[name]);
    const dollars = value => Number.isInteger(value) ? String(value) : value.toFixed(2);
    const inputs = [...root.querySelectorAll('input[name="box"]')];
    for (const input of inputs) {
      const variant = variants.get(input.value);
      input.disabled = !variant?.available;
      const card = input.closest('.choice');
      if (variant) {
        const price = variant.price / 100;
        const dim = dimensions[input.value];
        const servings = dim.jars * dim.size / 8;
        card.querySelector('strong').textContent = '$' + dollars(price);
        card.querySelector('small').textContent = `${servings} servings`;
      }
    }
    const checkout = get('purchase-link');
    const variantField = get('purchase-variant');
    function updateChoice(id) {
      const variant = variants.get(id);
      const dim = dimensions[id];
      if (!variant || !dim) {
        checkout.disabled = true;
        checkout.setAttribute('aria-disabled', 'true');
        get('purchase-text').textContent = data.unavailableLabel;
        return;
      }
      const price = variant.price / 100;
      const servings = dim.jars * dim.size / 8;
      inputs.forEach(input => {
        input.checked = input.value === id;
        input.closest('.choice').classList.toggle('selected', input.checked);
      });
      get('total-price').textContent = '$' + dollars(price);
      get('serving-summary').textContent = copy('servings', { servings });
      get('contents-summary').textContent = copy('contents', { jars: dim.jars, size: dim.size, count: language[dim.jars === 6 ? 'one' : 'two'] });
      get('selected-box').src = dim.size === 16 ? data.image16 : data.image32;
      get('selected-box').alt = copy('box_alt', { size: dim.size });
      get('box-caption').textContent = language[dim.jars === 6 ? 'caption_six' : 'caption_twelve'];
      get('shipping-summary').textContent = price >= 100 ? language.shipping_included : copy('shipping_remaining', { amount: dollars(100 - price) });
      get('shipping-summary').classList.toggle('qualified', price >= 100);
      get('selection-upgrade').hidden = id !== '53383155286289' || !variants.get('53383155384593')?.available;
      if (get('sticky-price')) get('sticky-price').textContent = `${dim.jars} × ${dim.size} oz jars · $${dollars(price)}`;
      variantField.value = id;
      checkout.disabled = !variant.available;
      checkout.setAttribute('aria-disabled', String(!variant.available));
      get('purchase-text').textContent = variant.available ? data.checkoutLabel : data.unavailableLabel;
      checkout.setAttribute('aria-label', `${data.checkoutLabel}: ${dim.jars} jars, ${dim.size} ounces each, $${dollars(price)}`);
    }
    root.addEventListener('change', event => {
      if (event.target.matches('input[name="box"]')) updateChoice(event.target.value);
    }, { signal });
    root.addEventListener('click', event => {
      const upgradeLink = event.target.closest('[data-upgrade]');
      if (upgradeLink) {
        event.preventDefault();
        const upgrade = inputs.find(input => input.value === '53383155384593');
        if (!upgrade || upgrade.disabled) return;
        updateChoice(upgrade.value);
        get('choose').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        upgrade.focus({ preventScroll: true });
      }
      if (event.target.closest('a[href="#shipping"]') && get('shipping')) get('shipping').open = true;
      if (event.target.closest('#purchase-link[aria-disabled="true"]')) event.preventDefault();
    }, { signal });
    const hero = root.querySelector('.hero');
    const chooser = get('choose');
    const sticky = get('sticky-buy');
    function updateSticky() {
      if (!hero || !chooser || !sticky) return;
      const bounds = chooser.getBoundingClientRect();
      const show = hero.getBoundingClientRect().bottom < 0 && !(bounds.top < window.innerHeight && bounds.bottom > 0);
      sticky.classList.toggle('visible', show);
      sticky.inert = !show;
      sticky.setAttribute('aria-hidden', String(!show));
    }
    window.addEventListener('scroll', updateSticky, { passive: true, signal });
    window.addEventListener('resize', updateSticky, { signal });
    updateChoice(inputs.find(input => input.checked)?.value || inputs[0]?.value);
    updateSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeFirstBox, { once: true });
  else initializeFirstBox();
  document.addEventListener('shopify:section:load', initializeFirstBox);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
